import {Patient} from 'gabi-api-ts/v2/patient/command/patient_command';
import {Patient as PatientQ} from 'gabi-api-ts/v2/patient/command/patient_command';
import {PatientQueryServiceClient} from 'gabi-api-ts/v2/patient/query/patient_query.client';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {PatientChildForm} from '@/components/business/common/patient/patient-child-form';
import {PatientRequestService} from '@/services/api-requests/patient-requests-service-ts';
import {BackendApiRefreshListeners} from '@/services/backend-api-refresh-listeners';
import {FeedbackAlertsService, FeedbackAlertType} from '@/services/feedback-alerts-service';

type PatientUpdateChildProps = {
    className?: string;
    patient: Patient | PatientQ;
    onChanged: (notSavedDataChild: boolean) => void;
};

function PatientUpdateChild(props: PatientUpdateChildProps) {
    const { t } = useTranslation();
    const [ loading, setLoading ] = useState(false);

    const handleFormChanged = (notSavedDataChild: boolean) => {
        if (props.onChanged) {
            props.onChanged(notSavedDataChild);
        }
    };

    const handleUpdatePatient = async (patient: Patient) => {
        setLoading(true);

        try {
            await PatientRequestService.updatePatient(patient);
            BackendApiRefreshListeners.refreshByCall(PatientQueryServiceClient, PatientQueryServiceClient.prototype.get);
            FeedbackAlertsService.add(FeedbackAlertType.SUCCESS, 'updatePatient', t('updateChild.updated') ?? 'Patient updated!');
            return patient;
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className={props.className}>
            <h3>{t('updateChild.title') ?? 'Child information'}</h3>
            <PatientChildForm patient={props.patient} loading={loading} onChanged={handleFormChanged} onSubmit={handleUpdatePatient} />
        </div>
    );
}

export {PatientUpdateChild};

